<template>
  <div class="component-content">
    <div class="title">
      <el-input
        class="search-input"
        v-model="searchKey"
        size="mini"
        placeholder="请输入同事姓名模糊搜索"
      ></el-input>
    </div>
    <el-table :data="paginationData" style="width: 100%" v-loading="loading">
      <el-table-column prop="name" label="姓名" width="80"> </el-table-column>
      <el-table-column prop="position" label="职务"> </el-table-column>
      <el-table-column prop="department" label="部门"> </el-table-column>
      <el-table-column v-if="!contactsSet" prop="mobile" label="手机">
      </el-table-column>
      <el-table-column v-if="!contactsSet" prop="telephone" label="座机">
      </el-table-column>
      <el-table-column
        v-if="!contactsSet"
        prop="email"
        label="邮箱"
        width="180px"
      >
      </el-table-column>
      <el-table-column
        v-if="!contactsSet && backRole('SYSTEM_3')"
        label="操作"
        width="80px"
      >
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            @click="handleUserSignImg(scope.row)"
            >电子签名</el-button
          >
        </template>
      </el-table-column>

      <el-table-column v-if="contactsSet" label="所属权限组" width="300">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            v-for="(item, i) in scope.row.roles"
            :key="i"
            plain
            >{{ item.name }}
          </el-button>
        </template>
      </el-table-column>
      <el-table-column v-if="contactsSet" label="操作" width="80px">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="handleDetail(scope.row)"
            >更改权限</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      v-if="filterData.length > pageSize"
      class="list-pagination"
      background
      :page-size="pageSize"
      :pager-count="9"
      :current-page="currentPage"
      layout="pager"
      :total="filterData.length"
      @current-change="handleCurrentChange"
    >
    </el-pagination>

    <section class="pop-room role-pop" v-if="setRoleStatus">
      <a
        href="javascript:;"
        @click="setRoleStatus = false"
        class="iconfont icon-close"
      ></a>
      <div class="pop-cont">
        <h3 class="title">将 {{ nowUser.name }} 的权限组设置为：</h3>
        <el-checkbox-group v-model="form.roleIds" class="el-radio-list">
          <el-checkbox v-for="(role, i) in roleArr" :key="i" :label="role.id">{{
            role.name
          }}</el-checkbox>
        </el-checkbox-group>
      </div>
      <div class="btn-room">
        <el-button @click="submitRole()" type="primary">确认提交</el-button>
      </div>
    </section>

    <section class="pop-room role-pop" v-if="setUserSignImgStatus">
      <a
        href="javascript:;"
        @click="setUserSignImgStatus = false"
        class="iconfont icon-close"
      ></a>
      <div class="pop-cont">
        <h3 class="title">{{ nowUser.name }} 的电子签章</h3>
        <img
          v-if="nowUser.sign"
          style="border: 1px #ccc solid"
          width="300"
          :src="nowUser.sign"
          alt=""
        />
        <span
          v-else
          style="
            border: 1px #ccc solid;
            width: 300px;
            box-sizing: border-box;
            padding: 20px;
            font-size: 16px;
            color: #666;
            display: block;
          "
          >暂未设置电子签章</span
        >
        <!-- 权限 -->
        <el-upload
          style="margin-top: 5px"
          v-if=""
          class="attachments-upload"
          :before-upload="handleBeforeUpload"
          :action="uploadUrl"
          :data="{ userId: nowUser.id }"
          :on-success="handleAvatarSuccess"
          :show-file-list="false"
        >
          <el-button size="small" type="primary" :loading="isUpload"
            >上传/重置电子签章</el-button
          >
        </el-upload>
      </div>
      <div class="btn-room">
        <!-- <el-button @click="submitUserSignImg()" type="primary">确认提交</el-button> -->
      </div>
    </section>
  </div>
</template>

<script>
import { mapState } from "vuex";

import Role from "@/Mixins/role";
export default {
  // props: ['contactData'],
  computed: {
    ...mapState({
      contactCurNode: (state) => state.main.contactCurNode,
      nowRouterUrl: (state) => state.main.nowRouterUrl,
    }),
  },
  mixins: [Role],
  data() {
    return {
      baseURL: axios.defaults.baseURL,
      uploadUrl: axios.defaults.baseURL + "/common/user/sign/upload",

      searchKey: "",

      nowUser: {},
      roleArr: [],
      form: {
        roleIds: "",
        userId: "",
      },
      setRoleStatus: false,
      contactsSet: false,
      setUserSignImgStatus: false,

      // 列表
      loading: true,
      pageSize: 30,
      currentPage: 1,
      listData: [],
      filterData: [],
      paginationData: [],

      isUpload: false,
    };
  },
  created() {
    this.getRoleArr();

    console.log(this.nowRouterUrl);
    if (this.nowRouterUrl.match("Set")) {
      this.contactsSet = true;
    }
  },
  mounted() {
    // console.log(1)
    this.getLists();
  },
  components: {},
  methods: {
    handleBeforeUpload() {
      this.isUpload = true;
    },
    handleAvatarSuccess(res, file) {
      if (!res.vo.data) {
        this.$message.error(res.msg);
        return;
      }
      this.nowUser.sign = res.vo.data;
      this.getLists();
      this.isUpload = false;
    },
    // 查看签名，显示弹窗
    handleUserSignImg(row) {
      this.nowUser = row;
      this.setUserSignImgStatus = true;
    },

    submitRole() {
      if (this.form.roleIds == "" || !this.form.userId) {
        this.$message.error("权限组不能为空");
        return;
      }
      console.log(this.nowUser);

      ajax.post(
        "/sys/grant/role",
        {
          roleIds: this.form.roleIds.join(","),
          userId: this.form.userId,
        },
        (res) => {
          this.setRoleStatus = false;
          this.nowUser = {};
          this.$message.success("用户权限设置成功");
          this.getLists();
        }
      );
    },
    handleDetail(row) {
      this.nowUser = row;
      this.setRoleStatus = true;
      // this.form.roleIds = row.roles ? row.roles[0].id : 2
      this.form.roleIds = row.roles ? row.roles.map((item) => item.id) : [2];
      this.form.userId = this.nowUser.id;
    },
    getRoleArr() {
      ajax.get("/sys/role/list", "", (res) => {
        this.roleArr = res.vo.array;
      });
    },
    // 当前页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPaginationData();
    },
    // 搜索筛选新闻数据
    getFilterData() {
      if (this.searchKey) {
        // 筛选出所有符合的数据
        this.filterData = [];
        for (let i = 0; i < this.listData.length; i++) {
          let _new = this.listData[i];
          if (_new.name.indexOf(this.searchKey) != -1) {
            this.filterData.push(_new);
          }
        }
      } else {
        this.filterData = this.listData;
      }
      this.currentPage = 1;
      this.getPaginationData();
    },
    // 分页筛选数据
    getPaginationData() {
      if (!(this.pageSize * (this.currentPage - 1) < this.filterData.length)) {
        this.currentPage = Math.ceil(this.filterData.length / this.pageSize);
      }
      if (this.currentPage == 0) {
        this.currentPage = 1;
      }

      // 分页筛选
      this.paginationData = this.filterData.slice(
        this.pageSize * (this.currentPage - 1),
        this.pageSize * this.currentPage
      );
    },
    // 获取列表
    getLists() {
      let _depId = "";
      if (this.contactCurNode.depId) {
        _depId = this.contactCurNode.depId;
      }

      let _url = "/dept/users";
      if (this.contactsSet) {
        // 后台权限管理
        _url = "/dept/role/users";
      }

      ajax.get(
        _url,
        {
          deptId: _depId,
        },
        (res) => {
          this.loading = false;
          this.filterData = this.listData = res.vo.array;
          this.getFilterData();
        }
      );
    },
  },
  watch: {
    contactCurNode() {
      this.loading = true;
      this.getLists();
    },
    searchKey() {
      if (this.searchKey) {
        this.getFilterData();
      } else {
        this.filterData = this.listData;
        this.getPaginationData();
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/page/main/contacts.vue